import React from "react";

const ChangePassword = ()=>{
    return (
        <>
           <h1>Change Password</h1>
        </>
    )
}


export default ChangePassword;